import { IProductResponse } from 'src/@interfaces'
import { getConfig } from 'src/helpers'
import { Api } from 'src/service/api'
import { UseProductsParams } from './types'

const { businessUnit } = getConfig()

class CatalogGetProductsError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'CatalogGetProductsError'
  }
}

export const getProductsFetcher = (
  params: UseProductsParams,
  options?: { signal?: AbortSignal },
) => {
  try {
    const { reseller, isGenericUser, magazine } = params
    const state = isGenericUser && magazine ? magazine.cycle.state : reseller?.addressHomeState
    const catalogSlug = isGenericUser ? null : reseller?.catalogSlug

    const body = {
      page: 1,
      pageSize: params.pageSize ?? 49,
      businessUnit,
      state,
      skus: params.products,
      catalogSlug,
      orderBy: params.orderBy,
    }

    return Api.post('/product/', body, { signal: options?.signal }).then(
      (response) => response.data as IProductResponse,
    )
  } catch (error) {
    window.NREUM.noticeError(new CatalogGetProductsError('Failed to fetch products'), {
      customAttributes: {
        error: error instanceof Error ? error.message : String(error),
        params,
      },
      customError: true,
    })

    throw error
  }
}
